/**
 * @file index.tsx
 *
 * @fileoverview Renders submit button that supports loading state.
 */
import { ReactNode } from 'react';
import { getCommonTranslations } from '~/jobiqo/utils/intl';
import Button, { ButtonProps } from '~/vcl/atoms/01-forms/01-button';
import { LoadingDotsIcon } from '~/vcl/icons/LoadingDots';

interface SubmitButtonProps extends ButtonProps {
  /**
   * The submitting flag.
   */
  isSubmitting: boolean;
  /**
   * The button children.
   */
  children: ReactNode;
}

export function SubmitButton({
  isSubmitting,
  children,
  ...rest
}: SubmitButtonProps) {
  const { LOADING_MESSAGE } = getCommonTranslations();

  return (
    <Button
      type="submit"
      disabled={isSubmitting}
      buttonStyle="primary"
      {...rest}
    >
      {isSubmitting ? <LoadingDotsIcon title={LOADING_MESSAGE} /> : children}
    </Button>
  );
}
export default SubmitButton;
